
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ObjectTypeInfo, PageBase, T4RentalObjectService } from 't4core';
import { T4DatatableWidget } from '../../../../t4common';
import { CreateAddonDialog } from '../../dialogs/CreateAddonDialog/CreateAddonDialog';
@Component({
  styleUrls: ['./addons.css'],
  selector: 'addons',
  templateUrl: './addons.component.html',
})
export class AddonsComponent extends PageBase implements OnInit {
    public myAddons: ObjectTypeInfo[] = [];
  public inheritedAddons: ObjectTypeInfo[] = []; 

  @ViewChild("addonList")
  private addonList: T4DatatableWidget;

    @ViewChild("inherited")
    private inherited: T4DatatableWidget;

  constructor(el: ElementRef, private route: ActivatedRoute, private svcObject: T4RentalObjectService) {
      super(el, "Settings");
    }

    async ngOnInit() {
        this.getAddons();
    }

    public async getAddons() {
        var token = this.UI.beginLoading("T4.Settings.Addons.msgLoading", "Loading addons", null);

        var allAddons = await this.Api.get<ObjectTypeInfo[][]>("RentalObject/GetAllAddons");

        this.myAddons = allAddons[0];
      var inheritedAddons = allAddons[1];

        var filteredInheritedAddons: ObjectTypeInfo[] = [];
        for (let a of inheritedAddons) {
            var overridden = inheritedAddons.find(x => x.OverridesType == a.Id.toString());
            if (!overridden) {
                filteredInheritedAddons.push(a);
            }
        }
        this.inheritedAddons = filteredInheritedAddons;



        if (this.myAddons && this.addonList) this.addonList.update();
        if (this.inheritedAddons && this.inherited) this.inherited.update();
        this.UI.loaderCompleted(token);
    }

    public async openAddon(addon: ObjectTypeInfo = null, editable: boolean = true) {
        var all = this.inheritedAddons.concat(this.myAddons);
        if (addon) {
            var index = -1;
            for (let i = 0; i < all.length; i++) {
                if (all[i].Id == addon.Id) index = i;
            }
            if (index > -1) all.splice(index, 1);
        }
        await this.Dialog.open(CreateAddonDialog, { width: '850px', data: { allAddons: all, inheritedAddons: this.inheritedAddons, addonToChange: addon ? addon : false, editable: editable } }).afterClosed().toPromise();
        this.getAddons();
    }

    public async deleteAddon(addon: ObjectTypeInfo) {

        var d = await this.UI.confirm("T4.Settings.Addons.titleConfirmDelete", "Confirm deletion", "T4.Settings.Addons.msgConfirmDelete", "Do you want to remove this addon?");

        if (d) {
            var deleted = await this.Api.delete<boolean>("RentalObject/DeleteAddon", { id: addon.Id });
            if (deleted) {
                this.getAddons();
            }
            else {
                alert("Error, could not be deleted");
            }
        }
    } 
}
